import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./app/page";
import MultipropriedadePage from "./app/multipropriedade/page";
import SaldoRetidoPage from "./app/saldo-retido/page";
import TermosPage from "./app/termos/page";
import PrivacidadePage from "./app/privacidade/page";
import SobrePage from "./app/sobre/page";
import NotFoundPage from "./app/not-found";
import ArticleView from "./pages/ArticleView";
import { ScrollManager } from "./components/shared/ScrollManager";
import { initGoogleAds } from "./lib/gtag";

export default function App() {
  useEffect(() => initGoogleAds(), []);
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/multipropriedade" element={<MultipropriedadePage />} />
        <Route path="/saldo-retido" element={<SaldoRetidoPage />} />
        <Route path="/termos" element={<TermosPage />} />
        <Route path="/privacidade" element={<PrivacidadePage />} />
        <Route path="/sobre" element={<SobrePage />} />
        <Route path="/:niche/:slug" element={<ArticleView />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
